import type { ReactNode } from 'react'
import { createContext, use, useState } from 'react'

export type Language = 'python' | 'js'

interface LanguageContextValue {
  language: Language
  setLanguage: (lang: Language) => void
  availableLanguages: Language[]
}

const LanguageContext = createContext<LanguageContextValue | null>(null)

const DEFAULT_AVAILABLE_LANGUAGES: Language[] = ['python', 'js']

export function LanguageProvider({
  children,
  defaultLanguage = 'python',
  availableLanguages = DEFAULT_AVAILABLE_LANGUAGES,
}: {
  children: ReactNode
  defaultLanguage?: Language
  availableLanguages?: Language[]
}) {
  const [language, setLanguage] = useState<Language>(defaultLanguage)

  return (
    <LanguageContext value={{ language, setLanguage, availableLanguages }}>
      {children}
    </LanguageContext>
  )
}

export function useLanguage() {
  const context = use(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider')
  }
  return context
}

export function useLanguageOptional() {
  return use(LanguageContext)
}
